import React, { useCallback } from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import logoTextSvg from './svg/logo-text.svg';
import logoMarkSvg from './svg/logo-mark.svg';
import { MainMenu, Layout } from 'scorer-ui-kit';
import menu from './pages/menu.json';
import styled from 'styled-components';
import DeviceSettings from './pages/DeviceSettings';
import LedStatus from './pages/LedStatus';
import AuditLogs from './pages/AuditLogs';
import DebugLogs from './pages/DebugLogs';
import DetectionSettings from './pages/DetectionSettings';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import './App.css';
import NotificationSettings from './pages/NotificationSettings';



const MainContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  & > div > div {
    max-width: 100%;
  }
  @media screen and (max-width: 1430px){
    & > div {
      padding: 70px 20px 70px 55px;
    }
  }
`;

const LanguageSelect = styled.select`
  position: absolute;
  right: 1%;
  bottom: 2%;
`;

function App() {
  const { t } = useTranslation(['Menu', 'Common']);

  const translateMenus = useCallback(() => {
    const data = menu.items.map((item: any) => {
      if (item.submenu && item.submenu.length > 0) {
        const submenu = item.submenu.map((submenu: any) => {
          return { ...submenu, 'title': t(submenu.title) };
        });
        if(item.title === 'settings'){
          return { ...item, 'title': t('Common:settings'), 'submenu': submenu };
        } else {
          return { ...item, 'title': t(item.title), 'submenu': submenu };
        }
      } else {
        return { ...item, 'title': t(item.title) };
      }
    });
    return { items: [...data] };

  }, [t]);

  const changeLang = (event: any) => {
    localStorage.setItem('language', event.target.value);
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Router>
      <Layout>
        <MainMenu content={translateMenus()} logoText={logoTextSvg} logoMark={logoMarkSvg} canAlwaysPin defaultMenuOpen={false} keepOpenText={t('Common:keepOpen')} autoHideText={t('Common:autoHide')} />
        <MainContainer>
          <LanguageSelect value={i18n.language.includes('en') ? 'en' : 'ja'} onChange={changeLang}>
            <option value='ja'>日本語</option>
            <option value='en'>English</option>
          </LanguageSelect>
          <Route path='/' exact component={LedStatus} />
          <Route path='/settings/device_settings' exact component={DeviceSettings} />
          <Route path='/settings/notification_settings' exact component={NotificationSettings} />
          <Route path='/settings/detection_settings' exact component={DetectionSettings} />
          <Route path='/logs/audit_logs' exact component={AuditLogs} />
          <Route path='/logs/debug_logs' exact component={DebugLogs} />
        </MainContainer>
      </Layout>
    </Router>
  );
}

export default App;
